import React from "react";
import { Link } from "react-router-dom";

const PLATFORM_LINKS = [
  { label: "Sign Up Free",        to: "/login" },
  { label: "Screening Console",   to: "/screening" },
  { label: "How It Works",        href: "/#how-it-works" },
  { label: "Features",            href: "/#methodology" },
  { label: "Pricing & Access",    href: "/#access" },
  { label: "Verify Certificate",  to: "/screening" },
];

const GLOBAL_NETWORK = [
  { label: "RSustain India",        href: "https://rsustain.com",    sub: "Resilient Sustainance Pvt Ltd" },
  { label: "RSustain UK",           href: "https://rsustain.co.uk",  sub: "Resilient Sustainance Limited" },
  { label: "RSustain USA",          href: "https://rsustain.net",    sub: "Resilient Sustainance LLC" },
  { label: "GSustain Qatar",        href: "https://gsustain.org",    sub: "Global Sustainability Sol. & Ser. QFZ LLC" },
  { label: "RSustain Carbon",       href: "https://rsustain.org",    sub: "RSustain Carbon Pvt Ltd, India" },
];

const LEGAL_LINKS = [
  { label: "Terms of Service",  href: "https://rsustain.org/terms" },
  { label: "Privacy Policy",    href: "https://rsustain.org/privacy-policy" },
  { label: "Methodology",       href: "/greensetu_methodology_v1.pdf" },
  { label: "Cookie Policy",     href: "https://rsustain.org/privacy-policy" },
];

function FooterLink({ label, to, href }) {
  if (to) return <Link to={to}>{label}</Link>;
  const isInternal = href && href.startsWith("/");
  return (
    <a href={href} {...(!isInternal && { target: "_blank", rel: "noopener noreferrer" })}>
      {label}
    </a>
  );
}

export default function Footer() {
  return (
    <footer className="landing-footer">
      <div className="landing-container">
        <div className="footer-top">

          {/* Brand column */}
          <div className="footer-brand">
            <img src="/rs-logo.png" alt="GreenSetu" />
            <div className="footer-brand-name">GreenSetu</div>
            <div className="footer-brand-tagline">
              Climate Intelligence for MSMEs, Lenders and Advisory Ecosystems.
              India's first GST-native carbon screening platform.
            </div>
            <div className="footer-brand-tagline" style={{ marginTop: "0.75rem", fontStyle: "italic", fontSize: "0.78rem", color: "rgba(255,255,255,0.35)" }}>
              Built for credibility · performance · accessibility
            </div>
          </div>

          {/* Platform */}
          <div>
            <div className="footer-col-heading">Platform</div>
            <ul className="footer-links">
              {PLATFORM_LINKS.map((item) => (
                <li key={item.label}>
                  <FooterLink {...item} />
                </li>
              ))}
            </ul>
          </div>

          {/* Global Network */}
          <div>
            <div className="footer-col-heading">Global Network</div>
            <ul className="footer-links footer-links--network">
              {GLOBAL_NETWORK.map((item) => (
                <li key={item.label}>
                  <a href={item.href} target="_blank" rel="noopener noreferrer">
                    {item.label}
                  </a>
                  {item.sub && <span className="footer-link-sub">{item.sub}</span>}
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <div className="footer-col-heading">Legal</div>
            <ul className="footer-links">
              {LEGAL_LINKS.map((item) => (
                <li key={item.label}>
                  <FooterLink {...item} />
                </li>
              ))}
            </ul>

            {/* Contact */}
            <div className="footer-col-heading" style={{ marginTop: "1.5rem" }}>Contact</div>
            <ul className="footer-links">
              <li><a href="tel:+918448278808">+91 84482 78808</a></li>
              <li><a href="mailto:carbon@rsustain.com">carbon@rsustain.com</a></li>
              <li style={{ fontSize: "0.78rem", color: "rgba(255,255,255,0.4)", lineHeight: 1.5 }}>
                427B, Second Floor, Vill. Hastsal,<br />
                Hastsal Road, New Delhi – 110059
              </li>
            </ul>
          </div>

        </div>

        <div className="footer-divider" />

        <div className="footer-copyright">
          © {new Date().getFullYear()} RSustain Carbon Private Limited. All rights reserved.
          GreenSetu is a trademark of the RSustain group.
        </div>
      </div>
    </footer>
  );
}
